import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../images/logo/logo.jpeg";
import './shining.css'; // Ensure this is your CSS file path

function Navbar() {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const closeNav = () => {
    setNavOpen(false);
  };

  const bookBtn = () => {
    // Check if the current location is already the home page
    if (window.location.pathname !== "/") {
      // Navigate to the home page
      navigate("/");
    }

    // After navigating to the home page, scroll to the pick-section
    setTimeout(() => {
      document
        .querySelector("#pick-section")
        .scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  {/* 
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
*/}



  return (
    <div style={{ marginBottom: "35px", backgroundColor:'#00b712s'  }}>
      
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "28px",
          
          background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)',
          backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          padding: '20px',
         // borderRadius: '10px',
          color: 'white',
          textAlign: 'center',
          animation: 'shine 3s infinite linear',
          marginBottom: "10px",
        }}
      >
        <a
          href="mailto:info@sleekexperience.com" 
          style={{
            color: "black",
            textDecoration: "none",
            marginRight: "25px",
            fontSize: "13px",
          }}
        >
          &#9993;Click To Email Us

        </a>
        <a
          href="tel: +1 (876)798-7720"
          style={{ color: "black", textDecoration: "none", fontSize: "13px" }}
        >
          &#x260E; +1 (876)798-7720
        </a>
      </div>

      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{
          // boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
          borderBottomLeftRadius: "30px",
          borderBottomRightRadius: "30px",
          height: "104px", width: '100%',
          //position: "fixed",
          marginTop: "37px",
          //background: 'linear-gradient(135deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)',
         // backgroundSize: '200% 200%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          padding: '20px',
          borderRadius: '10px',
          color: 'white',
          textAlign: 'center',
          animation: 'glow 1.5s infinite alternate, shine 1s infinite linear',
        }}
      > 
        {/* */}
        <div className="container">
          {/* Logo */}

            <Link
            className="navbar-brand"
            to="/"
            onClick={() => window.scrollTo(0, 0)}
          > 
        <img
          src={Logo}
          alt="logo-img"
          style={{  height: "102px", width: "195px", backgroundColor: '#fdf4dc', // backgroundColor: '#00b712',
          borderRadius:'25px'}}
        />
     
          </Link>

          {/* Mobile Menu Toggle */}
          <button className="navbar-toggler" type="button" onClick={toggleNav} style={{borderWidth:'2px', borderColor:'white', backgroundColor:'gold'}}>
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div
            className={`collapse navbar-collapse ${navOpen ? "show" : ""}`}
            style={{ backgroundColor: navOpen ? "black" : ""   }}
          >
            <ul
              className="navbar-nav ml-auto"
              style={{ paddingTop: "15px", paddingLeft: "4px" }}
            >
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    color: "#00FFFF",
                    transition: "color 0.3s",
                    marginLeft: "11px",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "white")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "#00FFFF")} // Reset color on mouse out
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/about"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "#00FFFF",
                    transition: "color 0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "white")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "#00FFFF")} // Reset color on mouse out
                >
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/"
                  onClick={() => {
                    bookBtn();
                    closeNav();
                  }}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "#00FFFF",
                    transition: "color 0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "white")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "#00FFFF")} // Reset color on mouse out
                >
                  Vehicle Models
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/testimonials"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "#00FFFF",
                    transition: "color 0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "white")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "#00FFFF")} // Reset color on mouse out
                >
                  Testimonials
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/contact"
                  onClick={closeNav}
                  style={{
                    fontSize: "18px",
                    paddingLeft: "1px",
                    marginLeft: "11px",
                    color: "#00FFFF",
                    transition: "color 0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "white")} // Change color on hover
                  onMouseOut={(e) => (e.target.style.color = "#00FFFF")} // Reset color on mouse out
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

      </nav>






    </div>
  );
}

export default Navbar;
